import React, { Component } from "react";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import BacktestService from "../../../service/backtest.service";
import MyClientTable from "./myClientTable";
import "./MyClients.style.scss";
// import data from "./data";
import Spinner from "../../common/spinner";
import FormDefaultData from "../Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/formDefaultData";

export class myClients extends Component {
  state = {
    defaultObj: {
      age: FormDefaultData["age"],
      dob: FormDefaultData["dob"],
      full_name: FormDefaultData["full_name"],
      zip_code: FormDefaultData["zip_code"],
      own_house: FormDefaultData["own_house"],
      adult_in_household: FormDefaultData["adult_in_household"],
      children_in_house: FormDefaultData["children_in_house"],
      household_health: FormDefaultData["household_health"],
      industry_employed_in: FormDefaultData["industry_employed_in"],
      annual_income: FormDefaultData["annual_income"],
      annual_expenses: FormDefaultData["annual_expenses"],
      net_worth: FormDefaultData["net_worth"],
      income_consistency: FormDefaultData["income_consistency"],
      investment_amount: FormDefaultData["investment_amount"],
      investment_period: FormDefaultData["investment_period"],
      max_loss: FormDefaultData["max_loss"],
    },
    loadingClients: false,
    clientsData: [],
  };

  componentDidMount() {
    this.setState({
      loadingClients: true,
    });
    BacktestService.getClients()
      .then((res) => {
        if (res) {
          this.setState({
            clientsData: res,
            loadingClients: false,
          });
          console.log({ getclients: res });
        }
      })
      .catch((err) => {
        this.setState({
          loadingClients: false,
        });
      });
  }
  newClientHandler = () => {
    // this.props.setBuildAPortfolioType("modelPortfolios");
    // this.props.resetBuildAPortfolioID();
    // this.props.resetBuildDirectReview();
    this.props.createNewQuestionnareClient(true);
    this.props.resetQuestionnaireForm();
    this.props.editQuestionnaireForm({ ...this.state.defaultObj });
    // setTimeout(() => browserHistory.push("/buildPortfolio/modelPortfolios"), 0);
    setTimeout(() => browserHistory.push("/riskQuestionnaire"), 0);
  };

  iconHandler = ({ type, data, risk_profile, client_id, client_name }) => {
    this.props.setBuildAPortfolioType("modelPortfolios");
    this.props.resetBuildAPortfolioID();
    this.props.resetBuildDirectReview();

    const _type = type.toLowerCase();

    this.props.myClientQuestionnaireActionType(_type);
    this.props.setMyClientsClientID(client_id);
    this.props.myClientSetRiskProfile({ risk_profile, client_name });

    if (_type === "edit") {
      this.props.editQuestionnaireForm({
        age: data["age"],
        dob: data["dob"],
        full_name: data["name"],
        zip_code: data["geo-zip-code"],
        own_house: data["geo-zip-code-owner"],
        adult_in_household:
          data["household-body-count"] * 1 -
          data["household-body-count-under-18"] * 1,
        children_in_house: data["household-body-count-under-18"],
        household_health: data["household-health"],
        industry_employed_in:
          data["industry-sectors-impacting-household"][0] &&
          data["industry-sectors-impacting-household"][0].split("-").length > 1
            ? data["industry-sectors-impacting-household"][0]
                .split("-")
                .filter((e) => e.toLowerCase() !== "industry")
                .join(" ")
            : data["industry-sectors-impacting-household"][0],
        annual_income: data["financial-income"],
        annual_expenses: data["financial-expenses"],
        net_worth: data["financial-net-worth-override"],
        income_consistency:
          data["income-consistency"] &&
          data["income-consistency"].split("-").length > 1
            ? data["income-consistency"]
                .split("-")
                .filter((e) => e.toLowerCase() !== "pay")
                .join(" ")
            : data["income-consistency"],
        investment_amount: data["investment-amount"],
        investment_period: data["investment-period"],
        max_loss: data["investment-max-loss"],
      });

      // setTimeout(
      //   () => browserHistory.push("/buildPortfolio/modelPortfolios"),
      //   0
      // );
      setTimeout(() => browserHistory.push("/riskQuestionnaire"), 0);
    } else if (_type === "new") {
      this.props.resetQuestionnaireForm();
      this.props.editQuestionnaireForm({ ...this.state.defaultObj });
      setTimeout(
        () => browserHistory.push("/buildPortfolio/modelPortfolios"),
        0
      );
      // skipping step 0, ie. form
      this.props.modelPortfolioStepHandler(1);
    } else if (_type === "analyse") {
      this.props.myClientAnalysisPortfolioActive(true);
      setTimeout(() => browserHistory.push("/create"), 10);
    }
  };
  render() {
    const { loadingClients, clientsData } = this.state;
    return (
      <div className="page-content">
        <div className="head-section">
          <h1 className="text-uppercase"></h1>
        </div>
        <div className="myClients">
          <div className="myClients__heading">
            <div></div>
            <div className="myClients__heading__title">
              <h2>My Clients</h2>
            </div>
            <div className="myClients__heading__btn">
              <button className="btn" onClick={() => this.newClientHandler()}>
                <i className="fa fa-plus" aria-hidden="true"></i>
                New Client
              </button>
            </div>
          </div>
          <div className="myClients__content">
            {loadingClients ? <Spinner /> : null}
            {clientsData && clientsData.length ? (
              <MyClientTable
                data={clientsData}
                iconHandler={this.iconHandler}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, (dispatch) => ({
  setBuildAPortfolioType: (payload) => {
    dispatch({
      type: "BUILD_A_PORTFOLIO_TYPE",
      payload,
    });
  },
  resetBuildAPortfolioID: () => {
    dispatch({
      type: "RESET_BUILD_A_PORTFOLIO_ACTIVE_ID",
    });
  },
  resetBuildDirectReview: () => {
    dispatch({
      type: "RESET_BUILD_DIRECT_REVIEW",
    });
  },
  resetQuestionnaireForm: () => {
    dispatch({
      type: "RESET_BUILD_A_PORTFOLIO_SET_RISK_QUESTIONNAIRE_FORM_DATA",
    });
  },
  editQuestionnaireForm: (payload) => {
    dispatch({
      type: "BUILD_A_PORTFOLIO_SET_RISK_QUESTIONNAIRE_FORM_DATA_EDIT",
      payload,
    });
  },
  createNewQuestionnareClient: (payload) => {
    dispatch({
      type: "BUILD_A_PORTFOLIO_CREATE_NEW_QUESTIONNAIRE_CLIENT",
      payload,
    });
  },
  myClientAnalysisPortfolioActive: (payload) => {
    dispatch({
      type: "SET_MYCLIENTS_ANALYSE_PORTFOLIO_ACTIVE",
      payload,
    });
  },
  myClientQuestionnaireActionType: (payload) => {
    dispatch({
      type: "SET_MYCLIENT_QUESTIONNAIRE_ACTION_TYPE",
      payload,
    });
  },
  setMyClientsClientID: (payload) => {
    dispatch({
      type: "SET_MYCLIENTS_CLIENT_ID",
      payload,
    });
  },
  modelPortfolioStepHandler: (payload) =>
    dispatch({
      type: "BUILD_A_PORTFOLIO_SET_MODEL_PORTFOLIO_STEP",
      payload,
    }),

  myClientSetRiskProfile: ({ risk_profile, client_name }) =>
    dispatch({
      type: "SET_MYCLIENTS_RISK_PROFILE",
      payload: { risk_profile, client_name },
    }),
}))(myClients);



// WEBPACK FOOTER //
// ./src/components/pages/MyClients/MyClients.jsx